import { pathOr } from 'ramda';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setSubdomain } from '../../../../../../common/actions/results';
import { selectResultsSubdomain } from '../../../../../../common/selectors/results';
import { IFeaturesMap } from '../../../../../../common/types/map';
import { IApplicationState, TThunkDispatch } from '../../../../../../common/types/redux';
import { mode } from '../../../../../../common/utils/mode';
import { selectMapBounds } from '../../../../../selectors';
import { TMapBounds } from '../../../../../types/mapBounds';
import { useFeaturesContext } from '../context';

export const SubdomainUpdater: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const { rbush } = useFeaturesContext();
  const subdomain = useSelector<IApplicationState, string>(selectResultsSubdomain);
  const { bounds, precision } = useSelector<IApplicationState, TMapBounds>(selectMapBounds);
  const features = useSelector<IApplicationState, IFeaturesMap>(state =>
    pathOr<IFeaturesMap>({}, [precision, 'features'], state.map.features),
  );

  React.useEffect(() => {
    if (!bounds) {
      return;
    }

    const featuresInBbox = rbush.search({
      minX: bounds[0][0],
      minY: bounds[0][1],
      maxX: bounds[1][0],
      maxY: bounds[1][1],
    });

    const nextSubdomain = mode(featuresInBbox.map(f => f.feature.properties.subdomain));
    if (!nextSubdomain || nextSubdomain === subdomain) {
      return;
    }

    dispatch(setSubdomain(nextSubdomain));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bounds, features]);

  return null;
};
